<template>
    <div
        class="tooltip"
        @mouseover="displayTooltip"
        @mouseleave="hideTooltip">

        <button
            :class="triggerClass"
            :aria-describedby="`tooltip-${uniqueId}`"
            :aria-controls="`tooltip-${uniqueId}`"
            @click="displayTooltip"
            @focus="displayTooltip"
            @blur="hideTooltip"
            class="tooltip__trigger">
            <slot></slot>
        </button>

        <div
            :aria-hidden="!tooltipVisible"
            :id="`tooltip-${uniqueId}`"
            role="tooltip"
            class="tooltip__box"
            :class="{'tooltip__box--visible': tooltipVisible}">
            {{ tooltip }}
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import { v4 as uuidv4 } from "uuid";

export default {
    name: "Tooltip",
    props: {
        tooltip: {
            type: String,
            required: true
        },
        triggerClass: {
            type: String,
            required: false,
            default: ""
        }
    },
    data() {
        return {
            uniqueId: uuidv4(),
            tooltipVisible: false
        };
    },
    mounted: function() {
    },
    destroyed: function() {
    },
    methods: {
        displayTooltip() {
            this.tooltipVisible = true;
        },
        hideTooltip() {
            this.tooltipVisible = false;
        },
    }
};
</script>